// AnalyticsPage.jsx
import React from 'react';

const AnalyticsPage = () => {
  return (
    <div>
      <h2>Analytics Page</h2>
      <p>This is the Analytics page content.</p>
    </div>
  );
};

export default AnalyticsPage;
